// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as Belt_Map from "@rescript/runtime/lib/es6/Belt_Map.js";
import * as LumiDate from "lumi-rescript/lib/es6/src/LumiDate.res.js";
import * as LumiJzon from "lumi-rescript/lib/es6/src/LumiJzon.res.js";
import * as LumiSort from "lumi-sort/lib/es6/src/LumiSort.res.js";
import * as LumiRequest from "lumi-rescript/lib/es6/src/LumiRequest.res.js";
import * as Document$LumiStore from "lumi-store/lib/es6/src/Document.res.js";
import * as Prelude$LumiCentral from "./Prelude.res.js";
import * as Sensor$LumiDocuments from "lumi-documents/lib/es6/src/Sensor.res.js";
import * as Facility$LumiDocuments from "lumi-documents/lib/es6/src/Facility.res.js";
import * as Statistics$LumiCentral from "./Statistics.res.js";
import * as PlaceClass$LumiDocuments from "lumi-documents/lib/es6/src/PlaceClass.res.js";
import * as FacilityMap$LumiDocuments from "lumi-documents/lib/es6/src/FacilityMap.res.js";
import * as SensorState$LumiDocuments from "lumi-documents/lib/es6/src/SensorState.res.js";
import * as SensorGroups$LumiStaticData from "lumi-static-data/lib/es6/src/SensorGroups.res.js";
import * as OccupationDetails$LumiCentral from "./OccupationDetails.res.js";

let jsonCodec = Jzon.object3(param => [
  param.facility,
  param.maps,
  param.groups
], param => ({
  TAG: "Ok",
  _0: {
    facility: param[0],
    maps: param[1],
    groups: param[2]
  }
}), Jzon.field("facility", Prelude$LumiCentral.documentCodec(Facility$LumiDocuments.Facility.jsonCodec)), Jzon.field("maps", FacilityMap$LumiDocuments.Schema.$$Map.jsonCodec(FacilityMap$LumiDocuments.FacilityMapInfo.jsonCodec)), Jzon.field("groups", Jzon.array(Statistics$LumiCentral.JsonCodecs.namedGroup)));

function sortedMaps(maps) {
  return LumiSort.stableSortOn(Belt_Map.toArray(maps), param => FacilityMap$LumiDocuments.FacilityMapInfo.sortKey(param[1]));
}

let FacilityInfo = {
  jsonCodec: jsonCodec,
  sortedMaps: sortedMaps
};

let jsonCodec$1 = Jzon.object2(param => [
  param.name,
  param.placeClass
], param => ({
  TAG: "Ok",
  _0: {
    name: param[0],
    placeClass: param[1]
  }
}), Jzon.field("name", Jzon.string), Jzon.field("placeClass", PlaceClass$LumiDocuments.PlaceClass.jsonCodec));

let SensorInfo = {
  jsonCodec: jsonCodec$1
};

function encode(d) {
  return d.toISOString();
}

function decode(str) {
  let x = new Date(str);
  if (Number.isNaN(x.getTime())) {
    return {
      TAG: "Error",
      _0: {
        NAME: "UnexpectedJsonValue",
        VAL: [
          [],
          str
        ]
      }
    };
  } else {
    return {
      TAG: "Ok",
      _0: x
    };
  }
}

let dateCodec = LumiJzon.keyCustom({
  TAG: "ToJsonKeyString",
  _0: encode
}, {
  TAG: "FromJsonKeyString",
  _0: decode
});

let getOccupationImagesResponse = LumiJzon.map(dateCodec, Jzon.string, LumiDate.Cmp);

let Codecs = {
  dateCodec: dateCodec,
  getOccupationImagesResponse: getOccupationImagesResponse
};

function getFacilities() {
  return LumiRequest.expectJSON(LumiRequest.make("/api/stallingsnet/facilities", "GET", undefined, undefined, undefined), Jzon.array(jsonCodec));
}

function getFacilityMap(facilityMapKey) {
  let facilityMapKeyString = Document$LumiStore.Key.toString(facilityMapKey);
  return LumiRequest.expectJSON(LumiRequest.make(`/api/stallingsnet/facility-map/` + facilityMapKeyString, "GET", undefined, undefined, undefined), LumiJzon.tuple2(Prelude$LumiCentral.documentCodec(FacilityMap$LumiDocuments.FacilityMap.jsonCodec), Sensor$LumiDocuments.Schema.$$Map.jsonCodec(jsonCodec$1)));
}

function getFacilityMapStatus(facilityMapKey) {
  let facilityMapKeyString = Document$LumiStore.Key.toString(facilityMapKey);
  return LumiRequest.expectJSON(LumiRequest.make(`/api/stallingsnet/facility-map/` + facilityMapKeyString + `/status`, "GET", undefined, undefined, undefined), Jzon.array(SensorState$LumiDocuments.SensorState.jsonCodec));
}

function getOccupationHistory(sensorKey) {
  let sensorKeyString = Document$LumiStore.Key.toString(sensorKey);
  return LumiRequest.expectJSON(LumiRequest.make(`/api/stallingsnet/sensor/` + sensorKeyString + `/occupation-history`, "GET", undefined, undefined, undefined), OccupationDetails$LumiCentral.OccupationHistory.jsonCodec);
}

function getOccupationSnapshots(occupationKey) {
  let occupationKeyString = Document$LumiStore.Key.toString(occupationKey);
  return LumiRequest.expectJSON(LumiRequest.make(`/api/stallingsnet/occupation/` + occupationKeyString + `/snapshots`, "GET", undefined, undefined, undefined), Jzon.array(OccupationDetails$LumiCentral.OccupationDetailsSnapshot.jsonCodec));
}

function formatGroupStatisticsParams(groupFullId, begin, end, interval) {
  return [
    SensorGroups$LumiStaticData.GroupFullId.toString(groupFullId),
    begin.toISOString(),
    end.toISOString(),
    interval === "week" ? "1W" : (
        interval === "day" ? "1D" : (
            interval === "month" ? "1M" : (
                interval === "quarterHour" ? "15m" : "1h"
              )
          )
      )
  ];
}

function getSensorGroupStateHistoryAggregates(groupFullId, begin, end, interval) {
  let match = formatGroupStatisticsParams(groupFullId, begin, end, interval);
  return LumiRequest.expectJSON(LumiRequest.make(`/api/stallingsnet/stats/group/` + match[0] + `/` + match[1] + `/` + match[2] + `/` + match[3], "GET", undefined, undefined, undefined), Jzon.array(Statistics$LumiCentral.JsonCodecs.sensorGroupStateHistoryAggregateRow));
}

function downloadSensorGroupStateHistoryAggregates(groupFullId, begin, end, interval, contentType) {
  let match = formatGroupStatisticsParams(groupFullId, begin, end, interval);
  let accept = contentType === "JSON" ? "application/json;charset=utf-8" : (
      contentType === "XLSX" ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" : "text/csv;charset=utf-8"
    );
  return LumiRequest.expectBody(LumiRequest.make(`/api/stallingsnet/stats/group/` + match[0] + `/` + match[1] + `/` + match[2] + `/` + match[3], "GET", Object.fromEntries([[
      "Accept",
      accept
    ]]), undefined, undefined), prim => prim.blob());
}

export {
  FacilityInfo,
  SensorInfo,
  Codecs,
  getFacilities,
  getFacilityMap,
  getFacilityMapStatus,
  getOccupationHistory,
  getOccupationSnapshots,
  formatGroupStatisticsParams,
  getSensorGroupStateHistoryAggregates,
  downloadSensorGroupStateHistoryAggregates,
}
/* jsonCodec Not a pure module */
